import { render, staticRenderFns } from "./batchShutdown.vue?vue&type=template&id=d50ba44a&"
import script from "./batchShutdown.vue?vue&type=script&lang=js&"
export * from "./batchShutdown.vue?vue&type=script&lang=js&"
import style0 from "./batchShutdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports